import './main.less';
import { actions, selectors } from './';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import renderViewsState from '../shared/render-views-state';
import Animate from '../shared/animation';

import Table from './components/table/main';
import Form from './components/form/main';
import Filters from '../shared/fixed-filters/main';
import Calendar from '../shared/calendar/main';
import Switch from '../top-affiliates/switch/main';

const Main = renderViewsState(
	props => (
		<Animate>
			<div className="container__content top-affiliates-list">
				<div className="container__content-title">
					<div className="container__content-title-position top-affiliates-title">
						<h1 className="title">{props.intl('Top countries')}</h1>
						<div className="margin-left-10 top-affiliates-list__total-users">
							<span>
								Total active:
								{Number(props.table.rows_count)}
							</span>
						</div>
					</div>
				</div>
				<div className="container__content-body">
					<div className="clearfix position-relative">
						<Filters {...props} {...props.filters} />
					</div>
					<div className="display-flex justify-content-flex-end">
						<Form {...props} />
						<Switch {...props} />
						<div className="ui-control-bar__item-position">
							<Calendar
								{...props.calendar}
								onInit={props.calendarInit}
								onToggle={props.calendarToggle}
								onChange={props.calendarChange}
								onApply={props.calendarApply}
								intl={props.intl}
							/>
						</div>
						<div>
							<button
								className="ui-btn ui-btn-primary save margin-left-5"
								onClick={props.apply}
							>
								{props.intl('Apply')}
							</button>
						</div>
					</div>

					<Table {...props} />
				</div>
			</div>
		</Animate>
	),
	'view'
);

export default connect(
	state => ({
		data: selectors.getData(state),
		loadingAffiliateId: selectors.getLoadingAffiliateId(state),
		loadingOfferCountryId: selectors.getLoadingOfferCountryId(state),
		periodSwitch: selectors.getPeriodSwitch(state),
		intl: selectors.getIntl(state),
		table: selectors.getTable(state),
		loadingAffiliateDataOnOffer: selectors.getLoadingAffiliateDataOnOffer(state),
		pagination: selectors.getPagination(state),
		expandedCountryIds: selectors.getExpandedCountryIds(state),
		expandedCountryOfferIds: selectors.getExpandedCountryOfferIds(state),
		isHiddenProfit: selectors.getIsHiddenProfit(state),
		filters: selectors.getFilters(state),
		progressBar: selectors.getProgressBar(state),
		calendar: selectors.getCalendar(state),
		can: selectors.getCan(state),
		error: selectors.getError(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/top-countries/main.js